import { EMPLOYMENT_TYPES } from 'cpool-constants';
import type { Schema_Beschaeftigung } from 'cpool-schemas';

const getDefaultIndependent = (): {
    beschaeftigung: Extract<Schema_Beschaeftigung, { beschaeftigungsart: typeof EMPLOYMENT_TYPES.SELBSTSTAENDIGER }>;
} => ({
    beschaeftigung: {
        beschaeftigungsart: EMPLOYMENT_TYPES.SELBSTSTAENDIGER,
        selbststaendiger: {
            abschreibungenLaufendesJahr: null,
            abschreibungenLetztesJahr: null,
            abschreibungenVor2Jahren: null,
            abschreibungenVor3Jahren: null,
            berufsbezeichnung: null,
            bruttoEinkommenLaufendesJahr: null,
            bruttoEinkommenLetztesJahr: null,
            bruttoEinkommenVor2Jahren: null,
            bruttoEinkommenVor3Jahren: null,
            einkommenssteuerLaufendesJahr: null,
            einkommenssteuerLetztesJahr: null,
            einkommenssteuerVor2Jahren: null,
            einkommenssteuerVor3Jahren: null,
            firma: {
                anschrift: {
                    hausnummer: null,
                    land: null,
                    ort: null,
                    plz: null,
                    strasse: null,
                },
                branche: null,
                name: null,
            },
            nettoeinkommenJaehrlich: null,
            selbststaendigSeit: null,
        },
        steuerklasse: null,
    },
});
export default getDefaultIndependent;
